var _linearGradient, _linearGradient2, _filter, _linearGradient3, _radialGradient, _clipPath, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _g, _rect, _rect2, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMsExcel(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 96,
    width: 96,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fefefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fefefe",
    stopOpacity: 0
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 36.357143,
    x2: 36.357143,
    xlinkHref: "#a",
    y1: 6,
    y2: 63.893143
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "c",
    colorInterpolationFilters: "sRGB",
    height: 1.384,
    width: 1.384,
    x: -0.192,
    y: -0.192
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.28
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 48,
    xlinkHref: "#a",
    y1: 20.220806,
    y2: 138.66119
  })), _radialGradient || (_radialGradient = /*#__PURE__*/React.createElement("radialGradient", {
    id: "e",
    cx: 48,
    cy: 90.171875,
    gradientTransform: "matrix(1.1573129 0 0 .99590774 -7.551021 .197132)",
    gradientUnits: "userSpaceOnUse",
    r: 42,
    xlinkHref: "#a"
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 84,
    rx: 6,
    width: 84,
    x: 6,
    y: 6
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 48,
    x2: 48,
    y1: 90,
    y2: 5.987717
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#006e33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#138841"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientTransform: "matrix(1.0058652 0 0 .994169 100 0)",
    gradientUnits: "userSpaceOnUse",
    x1: 45.447727,
    x2: 45.447727,
    y1: 92.539597,
    y2: 7.01654
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.588235
  }))), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientTransform: "matrix(1.0238095 0 0 1.0119048 -1.142857 -98.071429)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251034,
    x2: 32.251034,
    xlinkHref: "#h",
    y1: 6.131708,
    y2: 90.238609
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientTransform: "translate(0 -97)",
    gradientUnits: "userSpaceOnUse",
    x1: 32.251034,
    x2: 32.251034,
    xlinkHref: "#h",
    y1: 6.131708,
    y2: 90.238609
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "url(#i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12-95.03125c-5.5110903 0-10.03125 4.52016-10.03125 10.03125v71c0 5.5110902 4.5201598 10.03125 10.03125 10.03125h72c5.51109 0 10.03125-4.5201597 10.03125-10.03125v-71c0-5.51109-4.52016-10.03125-10.03125-10.03125z",
    opacity: 0.08,
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12-94.03125c-4.971633 0-9.03125 4.059617-9.03125 9.03125v71c0 4.9716329 4.0596171 9.03125 9.03125 9.03125h72c4.971633 0 9.03125-4.059617 9.03125-9.03125v-71c0-4.971633-4.059617-9.03125-9.03125-9.03125z",
    opacity: 0.1,
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12-93c-4.4091333 0-8 3.590867-8 8v71c0 4.4091333 3.5908667 8 8 8h72c4.409133 0 8-3.5908667 8-8v-71c0-4.409133-3.590867-8-8-8z",
    opacity: 0.2,
    transform: "scale(1 -1)"
  }), /*#__PURE__*/React.createElement("rect", {
    height: 85,
    opacity: 0.3,
    rx: 7,
    transform: "scale(1 -1)",
    width: 86,
    x: 5,
    y: -92
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#j)",
    height: 84,
    opacity: 0.45,
    rx: 6,
    transform: "scale(1 -1)",
    width: 84,
    x: 6,
    y: -91
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    fill: "url(#g)",
    height: 84,
    rx: 6,
    width: 84,
    x: 6,
    y: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12 6c-3.324 0-6 2.676-6 6v2 68 2c0 .334721.04135.6507.09375.96875.0487.295596.09704.596915.1875.875.00988.03038.020892.0636.03125.09375.098865.287771.2348802.547452.375.8125.1445918.273507.3156161.535615.5.78125s.3737765.473472.59375.6875c.439947.428056.94291.814526 1.5 1.09375.278545.139612.5734731.246947.875.34375-.2562018-.100222-.4867109-.236272-.71875-.375-.00741-.0044-.023866.0045-.03125 0-.031933-.0193-.062293-.04251-.09375-.0625-.120395-.0767-.2310226-.163513-.34375-.25-.1061728-.0808-.2132809-.161112-.3125-.25-.1779299-.161433-.3474596-.345388-.5-.53125-.1075789-.130255-.2183939-.265285-.3125-.40625-.025089-.03838-.038446-.08587-.0625-.125-.064763-.103032-.1302275-.204517-.1875-.3125-.1010083-.194706-.2056748-.415701-.28125-.625-.00796-.02181-.023589-.04055-.03125-.0625-.0318251-.09195-.0358045-.186831-.0625-.28125-.0303323-.106618-.0703894-.203031-.09375-.3125-.0728786-.341512-.125-.698205-.125-1.0625v-2-68-2c0-2.781848 2.2181517-5 5-5h2 68 2c2.781848 0 5 2.218152 5 5v2 68 2c0 .364295-.05212.720988-.125 1.0625-.04415.206893-.08838.397658-.15625.59375-.0077.02195-.0233.04069-.03125.0625-.06274.173739-.138383.367449-.21875.53125-.04158.0828-.07904.169954-.125.25-.0546.09721-.126774.18835-.1875.28125-.09411.140965-.204921.275995-.3125.40625-.143174.17445-.303141.346998-.46875.5-.01117.0102-.01998.02115-.03125.03125-.138386.125556-.285091.234436-.4375.34375-.102571.07315-.204318.153364-.3125.21875-.0074.0045-.02384-.0044-.03125 0-.232039.138728-.462548.274778-.71875.375.301527-.0968.596455-.204138.875-.34375.55709-.279224 1.060053-.665694 1.5-1.09375.219973-.214028.409366-.441865.59375-.6875s.355408-.507743.5-.78125c.14012-.265048.276135-.524729.375-.8125.01041-.03078.02133-.06274.03125-.09375.09046-.278085.1388-.579404.1875-.875.0524-.31805.09375-.634029.09375-.96875v-2-68-2c0-3.324-2.676-6-6-6z",
    fill: "url(#b)",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m12 90c-3.324 0-6-2.676-6-6v-2-68-2c0-.334721.04135-.6507.09375-.96875.0487-.295596.09704-.596915.1875-.875.00988-.03038.020892-.0636.03125-.09375.098865-.287771.2348802-.547452.375-.8125.1445918-.273507.3156161-.535615.5-.78125s.3737765-.473472.59375-.6875c.439947-.428056.94291-.814526 1.5-1.09375.278545-.139612.5734731-.246947.875-.34375-.2562018.100222-.4867109.236272-.71875.375-.00741.0044-.023866-.0045-.03125 0-.031933.0193-.062293.04251-.09375.0625-.120395.0767-.2310226.163513-.34375.25-.1061728.0808-.2132809.161112-.3125.25-.1779299.161433-.3474596.345388-.5.53125-.1075789.130255-.2183939.265285-.3125.40625-.025089.03838-.038446.08587-.0625.125-.064763.103032-.1302275.204517-.1875.3125-.1010083.194706-.2056748.415701-.28125.625-.00796.02181-.023589.04055-.03125.0625-.0318251.09195-.0358045.186831-.0625.28125-.0303323.106618-.0703894.203031-.09375.3125-.0728786.341512-.125.698205-.125 1.0625v2 68 2c0 2.781848 2.2181517 5 5 5h2 68 2c2.781848 0 5-2.218152 5-5v-2-68-2c0-.364295-.05212-.720988-.125-1.0625-.04415-.206893-.08838-.397658-.15625-.59375-.0077-.02195-.0233-.04069-.03125-.0625-.06274-.173739-.138383-.367449-.21875-.53125-.04158-.0828-.07904-.169954-.125-.25-.0546-.09721-.126774-.18835-.1875-.28125-.09411-.140965-.204921-.275995-.3125-.40625-.143174-.17445-.303141-.346998-.46875-.5-.01117-.0102-.01998-.02115-.03125-.03125-.138386-.125556-.285091-.234436-.4375-.34375-.102571-.07315-.204318-.153364-.3125-.21875-.0074-.0045-.02384.0044-.03125 0-.232039-.138728-.462548-.274778-.71875-.375.301527.0968.596455.204138.875.34375.55709.279224 1.060053.665694 1.5 1.09375.219973.214028.409366.441865.59375.6875s.355408.507743.5.78125c.14012.265048.276135.524729.375.8125.01041.03078.02133.06274.03125.09375.09046.278085.1388.579404.1875.875.0524.31805.09375.634029.09375.96875v2 68 2c0 3.324-2.676 6-6 6z",
    fill: "url(#e)",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m35.137985 76.283018-17.53629-3.02047v-23.945179-23.945178l4.2275-.711794c2.32512-.391487 10.32214-1.749579 17.77115-3.017983l13.54365-2.306189v30.016355c0 16.508998-.10568 30.001628-.23486 29.983628-.12917-.018-8.12619-1.39194-17.77115-3.05319zm5.41075-21.8714-2.63423-5.586808 2.55236-5.473995 2.55237-5.473996-.96572-.08403c-.53114-.04622-1.59485.02729-2.36379.163347l-1.39807.247378-1.399 3.521743c-.76945 1.936959-1.49097 3.413536-1.60337 3.281282-.11239-.132254-.43251-.874587-.71136-1.649628-.27886-.775041-.80913-2.229178-1.17838-3.231415l-.67137-1.822249-2.08315.216782c-1.14573.119231-2.12885.256879-2.18472.305885-.0559.04901.84686 2.251091 2.00604 4.893521 1.15919 2.642431 2.10911 4.960963 2.11094 5.152294.002.191332-1.02027 2.499677-2.27134 5.129654-2.55021 5.361035-2.55274 5.314855.29139 5.318985l1.72232.003 1.3898-3.44604c.76439-1.895321 1.49276-3.338686 1.61859-3.207474s.84629 1.788654 1.60103 3.683194l1.37225 3.44463 2.33268.15657c1.28297.0861 2.38135.1314 2.44083.10063.0595-.0308-1.07727-2.57002-2.5261-5.642762zm14.161 16.0326v-2.03546h4.54065 4.54065v-3.13149-3.13148h-4.54065-4.54065v-.93944-.93944h4.54065 4.54065v-3.13148-3.131485h-4.54065-4.54065v-.939444-.939444h4.54065 4.54065v-3.13148-3.131481h-4.54065-4.54065v-.939444-.939444h4.54065 4.54065v-3.13148-3.131481h-4.54065-4.54065v-.939444-.939444h4.54065 4.54065v-3.13148-3.131481h-4.54065-4.54065v-1.722314-1.722314h12.30672c9.15436 0 12.40297.09625 12.6825.375777.54371.543713.54371 45.050643 0 45.594353-.27953.27952-3.52814.37578-12.6825.37578h-12.30672zm21.29407-5.16695v-3.13148h-5.16694-5.16695v3.13148 3.13149h5.16695 5.16694zm0-8.14184v-3.131485h-5.16694-5.16695v3.131485 3.13148h5.16695 5.16694zm0-8.141853v-3.131481h-5.16694-5.16695v3.131481 3.13148h5.16695 5.16694zm0-8.141849v-3.131481h-5.16694-5.16695v3.131481 3.13148h5.16695 5.16694zm0-8.141849v-3.131481h-5.16694-5.16695v3.131481 3.13148h5.16695 5.16694z",
    fill: "#fefefe",
    strokeWidth: 0.313148
  })), /*#__PURE__*/React.createElement("rect", {
    height: 66,
    rx: 12,
    style: {
      opacity: 0.1,
      stroke: "#fefefe",
      strokeWidth: 0.5,
      strokeLinecap: "round",
      clipPath: "url(#f)",
      fill: "url(#d)",
      filter: "url(#c)"
    },
    width: 66,
    x: 15,
    y: 15
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMsExcel);
export default __webpack_public_path__ + "static/media/ms-excel.235858151e09a20fdfa90007526e1c46.svg";
export { ForwardRef as ReactComponent };